<template>
  <div class="component-container" v-if="isLoaded && isVisible">
    <h3 class="component-title" tabindex="0" v-band-title>{{bandTitle}}</h3>
    <cell-list-instant-play :cell-list="cellList" :thumbnail-info="thumbnailInfo"></cell-list-instant-play>
    <view-more v-if="hasViewMore" :route-to-list-fn="routeToList" :view-more-title="sectionInfo.title"></view-more>
  </div>
</template>
<script>
import store from '@/store'
import EventModelClass from '@/common/model/EventModelClass'
import { get } from 'lodash'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import CellListInstantPlay from '@/components/section/template/cell/CellListInstantPlayBand'
import { bandTitle } from '@/common/directives'
import { parseUrl } from 'query-string'
import { mapActions } from 'vuex'
import { FETCH_BAND_INFO } from '@/store/types/actions.type'
import { hasViewMore, routeToList, viewMoreTitle } from '@/common/util/common'
import ViewMore from '@/components/section/template/viewmore/ViewMore'
export default {
  name: 'TemplateInstantPlay',
  data () {
    return {
      cellList: [],
      isVisible: true,
      isLoaded: false,
      genTime: '',
      thumbnailInfo: ''
    }
  },
  props: {
    sectionInfo: {
      type: Object
    }
  },
  components: {
    CellListInstantPlay,
    ViewMore
  },
  directives: {
    bandTitle
  },
  computed: {
    hasMemorize () {
      return store.getters.hasMemorize(this.getMemorizeKey(get(this.sectionInfo, 'contentEvent', {})))
    },
    bandTitle () {
      return get(this.sectionInfo, 'title', '')
    },
    hasViewMore () {
      return hasViewMore(this.sectionInfo)
    },
    viewMoreTitle () {
      return viewMoreTitle(this.sectionInfo)
    }
  },
  methods: {
    ...mapActions({ fetchBandData: FETCH_BAND_INFO }),
    getMemorizeKey (viewMoreEvent) {
      const { query } = parseUrl(get(viewMoreEvent, 'url', ''))
      return get(query, 'uitype', '')
    },
    setData () {
      let memorize = this.hasMemorize
      if (memorize) {
        this.genTime = get(memorize, 'genTime', '')
        this.cellType = get(memorize, 'cellType', '')
        this.cellList = get(memorize, 'cellList', [])
        if (this.cellList.length === 0) this.isVisible = false
        this.isLoaded = true
        this.loading = false
      }
      this.fetchBandData(
        { eventModel: new EventModelClass(get(this.sectionInfo, 'contentEvent', {})),
          force: get(this.sectionInfo, 'forceRefresh', false) })
        .then((response) => {
          if (this.genTime !== get(response, 'genTime', '') || get(response, 'genTime', '') === null) {
            this.genTime = get(response, 'genTime', '')
            this.cellList = get(response, 'cellList', [])
            if (this.cellList.length === 0) this.isVisible = false
            if (get(this.$route, 'name', '') === 'my') this.isVisible = true
          }
          this.isLoaded = true
          this.loading = false
        })
      this.thumbnailInfo = getBandTypeInfoByCellType(get(this.sectionInfo, 'cellType', ''))
    },
    routeToList () {
      routeToList(this.sectionInfo, this.$route)
    }
  },
  created () {
    this.setData()
  }
}
</script>
